import { render, staticRenderFns } from "./MenuDropDown.vue?vue&type=template&id=130bc97e&"
import script from "./MenuDropDown.vue?vue&type=script&lang=js&"
export * from "./MenuDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports